import { UseQueryResult, useQuery } from 'react-query'
import request from '../../../request'
import { useBuildQueryParams } from '../../../../lib/hooks/useBuildQueryParams'
import { useDealership } from '../../../../store/zustand/dealershipStore'

type ResultType = {
  values: Array<{
    tag_name: string
    tag_id: number
    tag_code: string
    count: number
  }>
  utm_campaigns: Array<{ utm_campaign: string; count: number }>
  time_to_convert: number
  unique_site_visitors: number
  roas: Array<{ date: string; monetary_value: number }>
}

export const useGetDisplayConversionReports = ({
  campaign_id,
  filters,
}: {
  campaign_id?: string | number
  filters?: Record<string, unknown>
}): UseQueryResult<ResultType, Error> => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)

  return useQuery<ResultType, Error>(
    ['campaigns', campaign_id, 'reports', 'display', 'conversions', { queryParams }],
    ({ signal }) =>
      request<{ data: ResultType }>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/display/${campaign_id}/metrics/conversions`,
        method: 'GET',
        signal,
        params: {
          ...queryParams,
        },
      }).then((res: { data: ResultType }) => res.data),
    {
      enabled: !!campaign_id,
      keepPreviousData: true,
    },
  )
}
